import { EnumCountry } from 'tdc-web-backend/enums/enums';
import { TPostRegistration } from './interface';

export const initialState: TPostRegistration = {
  overview: {
    name: '',
    url: '',
    description: '',
    headquartersLocation: {
      country: '' as EnumCountry,
      city: '',
    },
    avatar: '',
  },
  admin: {
    jobTitle: '',
  },
};

export const labels = ['Overview', 'Admin'];

export const helperTexts = [
  '',
  '',
  'Your account administrator is user that registered your company account. This user will have full access to manage the company profile and its settings.',
  '',
];
